import React from 'react';
import { Box, TextField, Typography, Paper } from '@mui/material';
import { formatTimeToMMSS, parseMMSSToSeconds } from '../../utils/timeFormat';

const TimeInput = ({ value, onChange, label, dense = false, disabled = false }) => {
  const [minutes, seconds] = value.split(':').map(Number);

  const handleMinutesChange = (e) => {
    if (disabled) return;
    const newMinutes = parseInt(e.target.value, 10);
    if (!isNaN(newMinutes) && newMinutes >= 0) {
      onChange(formatTimeToMMSS(newMinutes * 60 + seconds));
    }
  };

  const handleSecondsChange = (e) => {
    if (disabled) return;
    const newSeconds = parseInt(e.target.value, 10);
    if (!isNaN(newSeconds) && newSeconds >= 0 && newSeconds < 60) {
      onChange(formatTimeToMMSS(minutes * 60 + newSeconds));
    }
  };

  const inputPadding = dense ? '6px' : '8px';
  const inputWidth = dense ? '56px' : '60px';
  const containerGap = dense ? 1 : 2;
  const paperPadding = dense ? 1 : 1.5;
  const separatorVariant = dense ? 'body2' : 'h6';

  return (
    <Box>
      {label && (
        <Typography
          variant={dense ? 'caption' : 'subtitle2'}
          gutterBottom={!dense}
          sx={{
            ...(dense ? { mb: 0.5 } : undefined),
            color: disabled ? 'text.disabled' : 'text.primary'
          }}
        >
          {label}
        </Typography>
      )}
      <Paper
        elevation={0}
        sx={{
          p: paperPadding,
          display: 'flex',
          alignItems: 'center',
          gap: containerGap,
          border: '1px solid',
          borderColor: disabled ? 'action.disabled' : 'divider',
          borderRadius: 1,
          bgcolor: disabled ? 'action.disabledBackground' : 'background.paper',
          opacity: disabled ? 0.6 : 1
        }}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body2" color="text.secondary" sx={{ minWidth: 20 }}>M</Typography>
          <TextField
            type="number"
            value={minutes}
            onChange={handleMinutesChange}
            disabled={disabled}
            inputProps={{
              min: 0,
              max: 59,
              style: {
                textAlign: 'center',
                padding: inputPadding,
                width: inputWidth
              }
            }}
            sx={{
              '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                display: 'block',
                margin: 0
              }
            }}
          />
        </Box>

        <Typography variant={separatorVariant} color="text.secondary">:</Typography>

        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body2" color="text.secondary" sx={{ minWidth: 20 }}>S</Typography>
          <TextField
            type="number"
            value={seconds}
            onChange={handleSecondsChange}
            disabled={disabled}
            inputProps={{
              min: 0,
              max: 59,
              style: {
                textAlign: 'center',
                padding: inputPadding,
                width: inputWidth
              }
            }}
            sx={{
              '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                display: 'block',
                margin: 0
              }
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default TimeInput; 